module.exports = __webpack_public_path__ + "img/credito-simple-pf.04101c25.webp";